module.exports = __webpack_public_path__ + "img/3ds_info.0d10acad.gif";